import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class HttpService {

  serviceUrl: string;
   requestHeaders: HttpHeaders;

  constructor(private _http: HttpClient) {
    this.serviceUrl = environment.serviceUrl;
    this.requestHeaders= new HttpHeaders;
  }

  /**
   * generic get service
   */


  private createHeader(contentType: string): any {
    return { headers: new HttpHeaders({ 'Content-Type': contentType }), responseType: 'text' };
  }
  //// used for Local controller Apis
  public getAllLocal(url: string) {
    let token = "Bearer " + sessionStorage.getItem("token");
    return this._http.get<any>(url, { headers: new HttpHeaders({ timeout: `${600000}`, "authorization": token }) });
  }

  public PutLocal(url: string, itemToSend: any) {
    const objectToSend = JSON.stringify(itemToSend);
    return this._http.put<any>(url, itemToSend, { headers: new HttpHeaders({ timeout: `${600000}` }) });
  }

  public SendLocal(url: string, itemToSend: any) {
    const objectToSend = JSON.stringify(itemToSend);
    let token = "Bearer " + sessionStorage.getItem("token");
    return this._http.post<any>(this.serviceUrl.concat(url), itemToSend, {
      headers: new HttpHeaders({ timeout: `${600000}`, "authorization": token }
      )
    });
  }


  public get(url: string, options = {}): Observable<any> {
    return this._http.get(this.serviceUrl.concat(url), options);
  }
  public post(url: string, data: object = {}, options = {}): Observable<any> {
    return this._http.post(this.serviceUrl.concat(url), data, options);
  }

  getAll<T>(url: string): Observable<T> {
    return this._http.get<T>(this.serviceUrl.concat(url));
  }

  getAllWithParameters(url: string, params: HttpParams): Observable<any> {
    return this._http.get(this.serviceUrl.concat(url, '/'), {params});
  }

  getSingle<T>(url: string, id: any): Observable<T> {
    return this._http.get<T>(this.serviceUrl.concat(url, '/', id.toString()));
  }

  getSingleWithQueryString<T>(url: string): Observable<T> {
    return this._http.get<T>(this.serviceUrl.concat(url));
  }

  Send(url: string, data: any) {
    return this._http.post(this.serviceUrl.concat(url), data);
  }

  add(url: string, itemToCreate: any): Observable<any> {
    const objectToSend = JSON.stringify(itemToCreate);
    return this._http.post(this.serviceUrl.concat(url), objectToSend);
  }

  addWithhHeaders(url: string, itemToCreate: any, requestHeaders: any) {
    this.requestHeaders = new HttpHeaders(requestHeaders);
    return this._http.post<any>(this.serviceUrl.concat(url), itemToCreate, { headers: this.requestHeaders });
  }

  addWithParameters(url: string, queryParams: HttpParams) {
    return this._http.post<any>(this.serviceUrl.concat(url), null, { params: queryParams });
  }

  update(url: string, data: any) {
    const objectToSend = JSON.stringify(data);
    return this._http.put(this.serviceUrl.concat(url), objectToSend);
  }

  updateWithParameters(url: string, queryParams: HttpParams) {​​​​
    return this._http.put<any>(this.serviceUrl.concat(url),null, {​​​​ params: queryParams }​​​​);
  }​​​​

  delete(url: string, data: any) {
    return this._http.delete(this.serviceUrl.concat(url),{params:data});
  }

  deleteByUrl(url: string) {
    return this._http.delete(this.serviceUrl.concat(url));
  }

  deleteWithParameters(url: string, queryParams: HttpParams) {​​​​
    return this._http.delete<any>(this.serviceUrl.concat(url), {​​​​ params: queryParams }​​​​);
  }​​​​

  checkCors(url: string) {
    return this._http.get(url, { observe: 'response' });
  }
}
